import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useParams } from 'react-router-dom';
import moment from 'moment-jalali';

const initialValues = {

};

const validationSchema = Yup.object({

});

const activeCase = [
    {
        id: 0,
        title: "غیر فعال"
    }, {
        id: 1,
        title: "فعال"
    }
]

const inputTypeCase = [
    {
        id: 0,
        type: "متن",
        title: ""
    }, {
        id: 1,
        type: "عدد",
        title: ""
    }, {
        id: 2,
        type: "تاریخ",
        title: ""
    }
]


const Update = () => {

    const { readDataByFilter: readDataById } = useEntityCrud('SubService/GetSubService');
    const { readDataById: readDataByIdValues } = useEntityCrud('SubService/GetSubService_TemplateValues');
    const { addData: addSubServiceImage } = useEntityCrud('SubService/SetSubServiceImage')
    const { addData: addSubServiceCount } = useEntityCrud('SubService/updatesubServiceStock')


    const { updateDate: updateTemplateValues } = useEntityCrud('SubService/UpdateSubService_TemplateValues');

    const { updateDate: updateDataSubService } = useEntityCrud('SubService/UpdateSubService');
    const { readData: readDataService } = useEntityCrud('Service/GetAllServices')
    
    const [serviceList, setServiceList] = useState([]);
    const [activeList, setActiveList] = useState([]);
    const navigate = useNavigate();
    const [createDate, setCreateDate] = useState(null)
    const { isEditMode, setIsEditMode } = (true)
    const [activeMode, setActiveMode] = useState("");
    const [idTemtValue, setIdTemtValue] = useState("");

    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: "",
        serviceId: ""
    })
    const [path, setPath] = useState([
        {
            type: "",
            title: "",
            templateValues: ""
        },
    ])

    const { id } = useParams();


    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYYjMMjDD")
    }

    function convertDateToInputValue(date) {
        if (!date) return "";
        const shamsiDate = new Date(date).toLocaleDateString("fa-ir-u-nu-latn", {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        });
        var arr = shamsiDate.split("/");
        return {
            day: parseInt(arr[2]),
            month: parseInt(arr[1]),
            year: parseInt(arr[0]),
        };
    }

    useEffect(() => {
        readDataService().then(res => {
            setServiceList(res.data.result.map(item => ({ value: item.id, label: item.title })))
        });
        setActiveList(activeCase.map(item => ({ value: item.id, label: item.title })))
    }, [])


    useEffect(() => {
         
        const postedData = {
            "subServiceId": parseInt(id)
        };
        readDataById(postedData).then(res => {
            const data = res.data.result;
            formik.setValues({
                ...data,
                title: data.title,
                activeId: { value: data.isActive === true ? 1 : 0, label: data.isActive === 0 ? "غیر فعال" : "  فعال" },
            });
            setActiveMode(data.isActive)
            setCreateDate(convertDateToInputValue(data.createDate))
            setOrgAddress({
                serviceId: { value: data.serviceId },

            })

            readDataByIdValues(id).then(res => {
                 
                const data = res.data.result;
                setPath(JSON.parse(data.templateValues));
                setIdTemtValue(data.id)
            })
        });
    }, []);


    useEffect(() => {
        const postedData = {
            "subServiceId": parseInt(id)
        };
        readDataById(postedData).then(res => {
            const data = res.data.result;
            console.log(data);

            formik.setValues({
                ...data,
                title: data.title,
                activeId: { value: data.isActive === true ? 1 : 0, label: data.isActive === 0 ? "غیر فعال" : "  فعال" },
            });
            setCreateDate(convertDateToInputValue(data.createDate))
            setOrgAddress({
                serviceId: { value: data.serviceId },

            })
        });
    }, [serviceList]);




    const onSubmit = (values) => {
         

        var priceArray = typeof (values.price) === "number" ? values.price : values.price.split(",");


        const postedData = {
            id: id,
            title: values.title,
            isActive: activeMode,
            description: values.description || "",
            serviceId: orgAddress.serviceId.value || values.serviceId,
            createDate: parseInt(convertToDate("")),
            price: typeof (values.price) === "number"  ? values.price : parseInt(priceArray[0] + priceArray[1] + priceArray[2]),
            rules: values.rules,
            specialPrice: values.specialPrice ? parseInt(values.specialPrice.toString().replace(/,/g,'')) : 0,
            specialQuantity: values.specialQuantity ? parseInt(values.specialQuantity) : 0,
            specialFromDate: values.specialFromDate ? parseInt(values.specialFromDate.toString().replace(/\//g,'')) : 0,
            specialFromTime: values.specialFromTime ? parseInt(values.specialFromTime.toString().replace(':','')) : 0,
            specialtoDate: values.specialtoDate ? parseInt(values.specialtoDate.toString().replace(/\//g,'')) : 0,
            specialtoTime: values.specialtoTime ? parseInt(values.specialtoTime.toString().replace(':','')) : 0

        };
        updateDataSubService(postedData).then(res => {
             
            if (res.status === 200) {

                if(values.image){
                    const imagePostedData = {
                        imageContent: values.image.split('base64,')[1],
                        subserviceId: id
                    };
                    addSubServiceImage(imagePostedData)
                }

                const stockPostedData = {
                    subServiceId: id,
                    stockMode: parseInt(values.stockMode),
                    quantity: parseInt(values.stockQuantity)
                }
                addSubServiceCount(stockPostedData)

                if (path.some(item => item.title !== "")) {
                    const string = JSON.stringify(path);
                    const postedDataValuesTemp = {
                        id: idTemtValue,
                        subServiceId: id,
                        templateValues: string
                    };
                    updateTemplateValues(postedDataValuesTemp).then(res => {
                         
                        if (res.data.status === false) {
                            res.data.errors?.map(error => toast.error(error.message));
                        }
                        else {
                            navigate("/subService");
                            toast.success('محصول/خدمت  با موفقیت در سیستم ثبت شد');
                        }
                    })
                }

                else {
                    navigate("/subService");
                    toast.success('محصول/خدمت  با موفقیت در سیستم ثبت شد');
                }
            }

            else
                res.data.errors.map(error => toast.error(error.message));
        })
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/subService', { replace: true });
    }


    return (
        <div className="card">

            <div className="card-header  d-flex justify-content-between">
                <div className="card-title"> ویرایش محصول/خدمت
                </div>

                <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>

            </div>
            <div className="card-body">
                <Form formik={formik} createDate={createDate} setCreateDate={setCreateDate} path={path}
                    setPath={setPath} id={id} idTemtValue={idTemtValue}
                    activeList={activeList} isEditMode={true} />
            </div>
        </div>
    );
}

export default Update;